import React from "react";
import "./CategoriesSection.scss";

const categories = [
  { name: "Vestidos", icon: "👗" },
  { name: "Fotografía", icon: "📸" },
  { name: "Maquillaje", icon: "💄" },
  { name: "Academias de baile", icon: "💃" },
  { name: "Banquetes", icon: "🍽" },
];

const CategoriesSection = () => {
  return (
    <section className="categoriesDreams" id="categorias">
      <div className="container">
        <div className="categoriesDreams__header">
          <span className="categoriesDreams__tag">
            Explora fácilmente
          </span>

          <h2>Encuentra todo para tus XV años</h2>

          <p>
            Ahorra tiempo y encuentra a los mejores proveedores en un solo lugar.
            Todo organizado para que planear tu evento sea fácil, rápido y
            emocionante.
          </p>
        </div>

        <div className="categoriesDreams__grid">
          {categories.map((cat, index) => (
            <a href="#proveedores" className="categoriesDreams__card" key={index}>
              <div className="categoriesDreams__icon">
                {cat.icon}
              </div>

              <h3>{cat.name}</h3>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;